import callAPiBase from './base';

const webUser = {
  list: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/webUserList',
      method: 'GET',
      useToken: true,
      title: 'Get Web User - webUserList',
      params,
    }),
  listFromModules: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/webUserListFromModules',
      method: 'POST',
      useToken: true,
      title: 'Get List From Modules - webUserListFromModules',
      data,
    }),

  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/webUserList',
      method: 'GET',
      useToken: true,
      title: 'Get Web User Details - webUserList',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/webUserCreate',
      method: 'POST',
      useToken: true,
      title: 'Create - webUserCreate',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/webUserUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Update - webUserUpdate',
      data,
    }),
  updateEmail: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/webUserUpdateEmail',
      method: 'PUT',
      useToken: true,
      title: 'Update Email - webUserUpdateEmail',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/webUserDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Web User - Delete',
      params,
    }),
  createSupervisorProfile: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/supervisorProfileOperationCreate',
      method: 'POST',
      useToken: true,
      title: 'Create - supervisorProfileOperationCreate',
      data,
    }),
  chargeRequestDelete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/chargeRequestDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Web Usr - Delete',
      params,
    }),
};

const appUser = {
  list: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/appUserList',
      method: 'GET',
      useToken: true,
      title: 'Get List - appUserList',
      params,
    }),
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/appUserList',
      method: 'GET',
      useToken: true,
      title: 'Get List - appUserGet',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/appUserCreate',
      method: 'POST',
      useToken: true,
      title: 'Create - appUserCreate',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/appUserUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Update - appUserUpdate',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/appUserDelete',
      method: 'DELETE',
      useToken: true,
      title: 'App User - Delete',
      params,
    }),
  toggleProfile: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/userProfileToggle',
      method: 'POST',
      useToken: true,
      title: 'Toggle - User Toggle Profile',
      data,
    }),
  userProfileRenew: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/userProfileRenew',
      method: 'POST',
      useToken: true,
      title: 'Renew - User Profile Renew',
      data,
    }),
  getByDocument: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/appUserGetByDocument',
      method: 'GET',
      useToken: true,
      title: 'Get List - appUserGetByDocument',
      params,
    }),
  merge: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/appUserMerge',
      method: 'POST',
      useToken: true,
      title: 'Merge - appUserMerge',
      data,
    }),
  appUserSendUserTransactionViaEmail: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/appUserSendUserTransactionViaEmail',
      method: 'POST',
      useToken: true,
      title: 'appUserSendUserTransactionViaEmail',
      data,
    }),
  appUserCancelBookedToken: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/appUserCancelBookedToken',
      method: 'POST',
      useToken: true,
      title: 'appUserCancelBookedToken',
      data,
    }),
  appUserCheckFacial: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/appUserCheckFacial',
      method: 'GET',
      useToken: true,
      title: 'Get - appUserCheckFacial',
      params,
    }),
  appUserFacialRegister: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/appUserFacialRegister',
      method: 'POST',
      useToken: true,
      title: 'Update - appUserFacialRegister',
      data,
    }),
  appUserCreateAddress: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/addressCreate',
      method: 'POST',
      useToken: true,
      title: 'Create - appUserCreateAddress',
      data,
    }),
  appUserDeleteAddress: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/addressDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Delete - appUserDeleteAddress',
      params,
    }),
};

const appUserDocument = {
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/appUserCreateDocument',
      method: 'POST',
      useToken: true,
      title: 'Create - appUserCreateDocument',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/appUserUpdateDocument',
      method: 'POST',
      useToken: true,
      title: 'Update - appUserUpdateDocument',
      data,
    }),
  delete: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/appUserDeleteDocument',
      method: 'POST',
      useToken: true,
      title: 'Delete - appUserDeleteDocument',
      data,
    }),
};

const appUserComment = {
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/appUserCreateComment',
      method: 'POST',
      useToken: true,
      title: 'Create - appUserCreateComment',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/appUserUpdateComment',
      method: 'PUT',
      useToken: true,
      title: 'Update - appUserUpdateComment',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/appUserDeleteComment',
      method: 'DELETE',
      useToken: true,
      title: 'Delete - appUserDeleteComment',
      params,
    }),
};

const appUserSettings = {
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/appUserSettingsGet',
      method: 'GET',
      useToken: true,
      title: 'GET - appUserSettingsGet',
      params,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/appUserSettingsUpdate',
      method: 'POST',
      useToken: true,
      title: 'Update - appUserSettingsUpdate',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/appUserSettingsDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Delete - appUserSettingsDelete',
      params,
    }),
};

export { webUser, appUser, appUserDocument, appUserComment, appUserSettings };
